import {LimsMeasurementType} from '../types/LimsMeasurementType'

export const getLimsMeasurementTypeLabel = (limsMeasurementType: LimsMeasurementType): string => {
  return limsMeasurementType.name ?? limsMeasurementType.code
}
